export function arrayFrom(arr) {
    if (!arr) return [];
    if (Array.isArray(arr)) return arr;

    return Object.values(arr);
}